import "./NewsImagePreview.scss";
import ImagePreview from "@/components/Common/ImagePreview/ImagePreview.vue";
import { createError } from "@/helpers/newsHelper";
import { updateLockingFile } from "@/helpers/fileHelper";
import { aiAttributionItems } from "@/helpers/commonHelper";

export default {
  name: "NewsImagePreview",
  extends: ImagePreview,
  data() {
    return {
      mainPeacock: "#00636C",
      mainRed: "#c55c52",
      mainGray: "#7a7a7a",
      aiAttributionItems
    };
  },
  props: [
    "newsMediaChannels",
    "disabled",
    "fileSizeConstraintValidationByKey",
    "showFitCoverCheckbox"
  ],
  computed: {
    showLockCheckbox() {
      return this.$store.state.selectedPrincipal?.showLockCheckbox;
    },
    fileAiAttribution: {
      get() {
        return this.fileToEdit?.ai_attribution ?? "";
      },
      set(value) {
        this.$set(this.fileToEdit, "ai_attribution", value ?? "");
      }
    },
    fileFitCover: {
      get() {
        return !!this.fileToEdit?.fit_cover;
      },
      set(value) {
        this.$set(this.fileToEdit, "fit_cover", !!value);
      }
    },
    shouldShowFitCoverCheckbox() {
      return this.showFitCoverCheckbox !== false;
    },
    imageUrl() {
      return this.getImageUrl(this.fileToEdit);
    }
  },
  methods: {
    createError,
    getImageUrl(image = this.fileToEdit) {
      const fitCover = image?.fit_cover;
      const croppedUrl =
        image?.[this.imageSizeField]?.[this.selectedRatio]?.url;

      if (fitCover && croppedUrl) {
        return croppedUrl;
      }

      return image?.url ?? image?.originalUrl ?? croppedUrl ?? "";
    },
    imgFilename(file) {
      return file?.url?.split("/").reverse()[0];
    },
    async updateFile(file) {
      await updateLockingFile(file.id, file.url, file.locked);
    },
    //remove or add publication-channel
    checkFileSizes(file) {
      if (!this.showImageAspectRatioButtons) {
        return !file?.image_sizes?.["16:9"];
      }
      if (!file?.image_sizes) return true;
      if (!file.image_sizes["16:9"]) return true;
      if (!file.image_sizes["3:1"]) return true;
      if (!file.image_sizes["1/1 (Mobil)"]) return true;
    },
    pictureCanBeCroppedOrResized(url) {
      return [".gif", ".pdf"].every(suffix => !url?.endsWith(suffix));
    },
    toggleChannel(channelValue) {
      if (this.fileToEdit.channels.includes(channelValue)) {
        this.fileToEdit.channels = this.fileToEdit.channels.filter(item => {
          return item !== channelValue;
        });
        this.fileToEdit.channels.reverse().reverse();
      } else {
        this.fileToEdit.channels.push(channelValue);
      }
      this.$emit("channelsChanged");
    },
    getFileSizeConstraintValidationKey(file, index) {
      return file?.id || file?._id || file?.url || file?.originalUrl || index;
    },
    getFileSizeConstraintValidation(file, index) {
      const key = this.getFileSizeConstraintValidationKey(file, index);
      return (
        this.fileSizeConstraintValidationByKey?.[key] ?? {
          hasFileSizeIssue: false,
          hasCopyrightIssue: false,
          hasIssue: false,
          statusLabel: "",
          previewStatusLabel: "",
          invalidChannelTitles: [],
          invalidCopyrightChannelTitles: [],
          imageSize: null,
          fileSizeKbText: null
        }
      );
    },
    joinLabelList(labels = []) {
      if (!labels.length) return "";
      if (labels.length === 1) {
        return `Kanal "${labels[0]}"`;
      }
      if (labels.length === 2) {
        return `Kanäle "${labels[0]}" und "${labels[1]}"`;
      }
      return `Kanäle ${labels
        .slice(0, -1)
        .map(l => `"${l}"`)
        .join(", ")} und "${labels[labels.length - 1]}"`;
    },
    formatFileSizeConstraintWarning(fileValidation) {
      if (!fileValidation?.hasIssue) {
        return "";
      }
      const messages = [];

      if (fileValidation.hasFileSizeIssue) {
        const channels = this.joinLabelList(fileValidation.invalidChannelTitles);
        const status = fileValidation?.statusLabel?.toLowerCase();
        const sizeParts = [];
        if (fileValidation.imageSize) {
          sizeParts.push(
            `${fileValidation.imageSize.width} × ${fileValidation.imageSize.height} px`
          );
        }
        if (fileValidation.fileSizeKbText) {
          sizeParts.push(fileValidation.fileSizeKbText);
        }
        const sizeText = sizeParts.length
          ? `Original ${sizeParts.join(" · ")}`
          : "Originalgröße";
        messages.push(`${sizeText} – ${status} für ${channels}.`);
      }

      if (fileValidation.hasCopyrightIssue) {
        const channels = this.joinLabelList(
          fileValidation.invalidCopyrightChannelTitles?.length
            ? fileValidation.invalidCopyrightChannelTitles
            : fileValidation.invalidChannelTitles
        );
        messages.push(
          channels
            ? `Copyright/Urheber fehlt für ${channels}.`
            : "Copyright/Urheber fehlt."
        );
      }

      return messages.join(" ");
    }
  }
};
